var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 1C0.25 0.801088 0.329018 0.610322 0.46967 0.46967C0.610322 0.329018 0.801088 0.25 1 0.25H17C17.1989 0.25 17.3897 0.329018 17.5303 0.46967C17.671 0.610322 17.75 0.801088 17.75 1C17.75 1.19891 17.671 1.38968 17.5303 1.53033C17.3897 1.67098 17.1989 1.75 17 1.75H1C0.801088 1.75 0.610322 1.67098 0.46967 1.53033C0.329018 1.38968 0.25 1.19891 0.25 1ZM0.25 6C0.25 5.80109 0.329018 5.61032 0.46967 5.46967C0.610322 5.32902 0.801088 5.25 1 5.25H12C12.1989 5.25 12.3897 5.32902 12.5303 5.46967C12.671 5.61032 12.75 5.80109 12.75 6C12.75 6.19891 12.671 6.38968 12.5303 6.53033C12.3897 6.67098 12.1989 6.75 12 6.75H1C0.801088 6.75 0.610322 6.67098 0.46967 6.53033C0.329018 6.38968 0.25 6.19891 0.25 6ZM0.25 11C0.25 10.8011 0.329018 10.6103 0.46967 10.4697C0.610322 10.329 0.801088 10.25 1 10.25H6C6.19891 10.25 6.38968 10.329 6.53033 10.4697C6.67098 10.6103 6.75 10.8011 6.75 11C6.75 11.1989 6.67098 11.3897 6.53033 11.5303C6.38968 11.671 6.19891 11.75 6 11.75H1C0.801088 11.75 0.610322 11.671 0.46967 11.5303C0.329018 11.3897 0.25 11.1989 0.25 11Z",
    fill: "#344054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListed);
export default __webpack_public_path__ + "static/media/listed.e8d726e401d0da787cfdbc96e40a8f9d.svg";
export { ForwardRef as ReactComponent };